import common from './common';
import time from './time';
import admin from './admin';
import vacation from './vacation';
import absence from './absence';
import calendar from './calendar';
import company from './company';
import flextime from './flextime';
import requests from './requests';

// Neue Namensräume hier ergänzen (eine Zeile je Datei).
const en = { ...common, ...time, ...admin, ...vacation, ...absence, ...calendar, ...company, ...flextime, ...requests };

export default en;
